export default __webpack_public_path__ + "static/media/HSN_SAC.3cdc7055.xlsx";